// extracted by mini-css-extract-plugin
export var active = "MobileDropdown-module--active--642a7";
export var dropLink = "MobileDropdown-module--dropLink--fa1e0";
export var mainBox = "MobileDropdown-module--mainBox--724fb";